import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import InformationWeCollect from "./sections/InformationWeCollect";
import HowWeUseInformation from "./sections/HowWeUseInformation";
import ContactFormsAndBusinessInquiries from "./sections/ContactFormsAndBusinessInquiries";
import CookiesAndAnalytics from "./sections/CookiesAndAnalytics";
import DataSharing from "./sections/DataSharing";
import DataSecurity from "./sections/DataSecurity";
import DataRetention from "./sections/DataRetention";
import ThirdPartyLinks from "./sections/ThirdPartyLinks";
import UserRights from "./sections/UserRights";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Introduction />
      <InformationWeCollect />
      <HowWeUseInformation />
      <ContactFormsAndBusinessInquiries />
      <CookiesAndAnalytics />
      <DataSharing />
      <DataSecurity />
      <DataRetention />
      <ThirdPartyLinks />
      <UserRights />
      <ContactInformation />
      <Footer />
    </div>;
}